import { Rating } from "../models/Rating";
import { RatingsFullDTO } from "../dto/RatingsFullDTO";

export const ratingMapper = (ratings: RatingsFullDTO): Rating => {
  return new Rating({
    id: ratings.ratingId,
    name: ratings.ratingName,
    displayOrder: ratings.displayOrder,
    active: ratings.active === "Y",
    overriddenBy: ratings.overriddenBy,
    testMinCrew: ratings.testMinCrew,
    testMaxCrew: ratings.testMaxCrew,
    testable: ratings.testable === "Y",
    category: ratings.ratingCategory,
    programId: ratings.programId,
  });
};
